import { render, staticRenderFns } from "./personal-profile-full.vue?vue&type=template&id=5f477765&"
import script from "./personal-profile-full.vue?vue&type=script&lang=js&"
export * from "./personal-profile-full.vue?vue&type=script&lang=js&"
import style0 from "./personal-profile-full.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/administracion-frontend/administracion-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f477765')) {
      api.createRecord('5f477765', component.options)
    } else {
      api.reload('5f477765', component.options)
    }
    module.hot.accept("./personal-profile-full.vue?vue&type=template&id=5f477765&", function () {
      api.rerender('5f477765', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/components/admin-personal/personal-profile-full/personal-profile-full.vue"
export default component.exports